export const ASSESSMENT_STATUS = {
  NOT_ANSWERED: "notAnswered",
  NOT_VISITED: "notVisited",
  MARKED_FOR_REVIEW: "markedForReview",
  ANSWERED_AND_SAVED: "answeredAndSaved",
  ANSWERS_NOT_SAVED: "answersNotSaved",
};
 
export const ASSESSMENT_STATUS_LABELS = {
  [ASSESSMENT_STATUS.NOT_ANSWERED]: "Not Answered",
  [ASSESSMENT_STATUS.NOT_VISITED]: "Not Visited",
  [ASSESSMENT_STATUS.MARKED_FOR_REVIEW]: "Marked for Review",
  [ASSESSMENT_STATUS.ANSWERED_AND_SAVED]: "Answered and Saved",
  [ASSESSMENT_STATUS.ANSWERS_NOT_SAVED]: "Answers Not Saved",
};
 
export const ASSESSMENT_STATUS_ORDER = [
  ASSESSMENT_STATUS.NOT_ANSWERED,
  ASSESSMENT_STATUS.NOT_VISITED,
  ASSESSMENT_STATUS.MARKED_FOR_REVIEW,
  ASSESSMENT_STATUS.ANSWERED_AND_SAVED,
  ASSESSMENT_STATUS.ANSWERS_NOT_SAVED,
];
 
 